/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOwnersByInstrumentTokensRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetOwnersByInstrumentTokens.pb'
import {GetOwnersByInstrumentTokensResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetOwnersByInstrumentTokens.pb'


export const getOwnersByInstrumentTokens = (request: GetOwnersByInstrumentTokensRequest, options?: CashRequestOptions) => post<GetOwnersByInstrumentTokensRequest, GetOwnersByInstrumentTokensResponse>("/2.0/cash/get-owners-by-instrument-tokens", request, {...options, rejectOnError: true })